export const ITALIC_KEYBOARD_SHORTCUT = 'mod+i';
export const ITALIC_UPCASED_TYPE = 'Italic';
export const ITALIC_TAG_NAME = 'em';
